/** Portal list URL for self-service student exams */
export const STUDENT_EXAMS_LIST = "/students/exams";

export function isStudentOwnedExamFlow(pathname = "") {
  const p = pathname || "";
  return (
    p.startsWith(STUDENT_EXAMS_LIST) ||
    p.startsWith("/student/exam-guide") ||
    p.startsWith("/student/solve-exam")
  );
}

function withExamQuery(path, { name, returnTo } = {}) {
  const q = new URLSearchParams();
  if (name) q.set("name", name);
  if (returnTo) q.set("returnTo", returnTo);
  const qs = q.toString();
  return qs ? `${path}?${qs}` : path;
}

export function studentSolveExamPath(examId, name) {
  return withExamQuery(`/student/solve-exam/${examId}`, { name });
}

export function studentExamResultPath(examId, name) {
  const q = name ? `?name=${encodeURIComponent(name)}` : "";
  return `/exam-result/${examId}${q}`;
}

/** API error body from student exam endpoints (e.g. already answered). */
export function getStudentExamApiError(error) {
  const data = error?.response?.data;
  return {
    code: data?.code,
    message: data?.message || error?.message || "Something went wrong",
    alreadyAnswered:
      data?.code === 400 &&
      typeof data?.message === "string" &&
      /already answered/i.test(data.message),
  };
}
